import useStorage from "hooks/useStorage";

const updateCredInnerHtml = (innerHTML, token) => {
  const { getItem } = useStorage();
  const tmpToken = token ?? getItem("token");

  if (!innerHTML) {
    return "";
  }

  return innerHTML.replace(/(\ssrc=['"])([^'"]*)['"]/g, (match, p1, p2) => {
    const credParam = `cred=${tmpToken}`;
    const separator = p2.includes("?") ? "&" : "?";
    const closingQuote = p1.charAt(p1.length - 1);

    if (p2.includes("cred=")) {
      const replacedValue = p2.replace(/(cred=)[^&'"]*(['"]|$)/, `$1${tmpToken}$2${closingQuote}`);
      return `${p1}${replacedValue}`;
    }
    return `${p1}${p2}${separator}${credParam}${closingQuote}`;
  });
};

const setCredential = (urlFile) => {
  const { getItem } = useStorage();
  const token = getItem("token");
  return `${urlFile}&cred=${token}`;
};

const history = {
  navigate: null,
  location: null,
};

const toast = null;

const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (error) {
    // eslint-disable-next-line
    console.error(error);
    return false;
  }
};

const navigate = (link, redir = true) => {
  history.navigate(link, redir);
};

function maskEmail(email) {
  if (typeof email !== "string" && typeof email !== "number") {
    return "*****";
  }

  if (!email.includes("@")) {
    return `${email.slice(0, 2)}*****`; // Mengembalikan username yang di-mask tanpa domain
  }

  const parts = email.split("@");
  const username = parts[0];
  const domain = parts[1];

  let maskedUsername = "";
  if (username.length === 1) {
    maskedUsername = `${username}***`;
  } else if (username.length > 1 && username.length < 5) {
    maskedUsername = `${username.charAt(0)}***`;
  } else if (username.length >= 5) {
    maskedUsername = `${username.slice(0, 2)}***${username.charAt(username.length - 1)}`;
  }

  return `${maskedUsername}@${domain}`;
}

export default {
  updateCredInnerHtml,
  setCredential,
  history,
  toast,
  isIframe,
  navigate,
  maskEmail,
};
